module.exports = __webpack_public_path__ + "img/food_thai.daee1065.png";